var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * API service for the vocabulary derivation rule admin GUI (CZNA-365, epic
 * CZNA-297, child 3/4).
 *
 * Consumes the contract exposed by `VocabularyDerivationRuleAdminController`
 * (base `czna-authorities/admin/vocabulary/derivation-rules`). Follows the
 * project's `useOkapiKy()` pattern — see `validationRulesService.ts` and
 * MEMORY: never put `ky` into react hook deps; capture by closure or key
 * react-query on params.
 *
 * Endpoints:
 *  - `fetchVocabularyDerivationRules` — GET list (plain array, all rules).
 *  - `fetchVocabularyDerivationRule`  — GET single rule (404 → HTTPError).
 *  - `createVocabularyDerivationRule` — POST create (201; 400 on invalid payload).
 *  - `updateVocabularyDerivationRule` — PUT update (200; 400/404/409 optimistic-lock).
 *  - `deleteVocabularyDerivationRule` — DELETE (204; 404).
 *  - `fetchVocabularyDerivationRuns`  — GET run audit trail (plain array, offset/limit).
 *  - `deriveVocabularyDerivationRule` — POST derive-now, then poll its job until done (dry-run supported).
 */
import { getHeaders } from './apiUtils';
import { API_PATHS, CZNA_VOCABULARY_DERIVATION_RULE_DETAIL, } from '../types/apiPaths';
/** GET .../derivation-rules — all rules, ordered by vocabularyType. Plain array, no envelope. */
export var fetchVocabularyDerivationRules = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(API_PATHS.CZNA_VOCABULARY_DERIVATION_RULES, {
                headers: getHeaders(),
            }).json()];
    });
}); };
/** GET .../derivation-rules/{id} — single rule. 404 surfaces as an HTTPError. */
export var fetchVocabularyDerivationRule = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(CZNA_VOCABULARY_DERIVATION_RULE_DETAIL(id), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/** POST .../derivation-rules — create a new rule. 201 on success; 400 on invalid payload. */
export var createVocabularyDerivationRule = function (ky, body) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(API_PATHS.CZNA_VOCABULARY_DERIVATION_RULES, {
                headers: getHeaders(),
                json: body,
            }).json()];
    });
}); };
/**
 * PUT .../derivation-rules/{id} — update a rule. The `expectedUpdatedAt`
 * token in the body drives optimistic locking; a stale token returns 409
 * which the caller surfaces as a conflict banner.
 */
export var updateVocabularyDerivationRule = function (ky, id, body) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.put(CZNA_VOCABULARY_DERIVATION_RULE_DETAIL(id), {
                headers: getHeaders(),
                json: body,
            }).json()];
    });
}); };
/** DELETE .../derivation-rules/{id} — removes a rule (204). */
export var deleteVocabularyDerivationRule = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.delete(CZNA_VOCABULARY_DERIVATION_RULE_DETAIL(id), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * GET .../derivation-rules/runs — run audit trail, newest first. Plain array
 * response (no `X-Total-Records` header) — `offset`/`limit` bound the page but
 * the caller cannot know the total count from this response alone.
 */
export var fetchVocabularyDerivationRuns = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var sp;
        var _a, _b;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            sp = new URLSearchParams();
            if (params.ruleId)
                sp.append('ruleId', params.ruleId);
            sp.append('offset', String((_a = params.offset) !== null && _a !== void 0 ? _a : 0));
            sp.append('limit', String((_b = params.limit) !== null && _b !== void 0 ? _b : 50));
            return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_VOCABULARY_DERIVATION_RULES_RUNS, "?").concat(sp.toString()), {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/** CZNA-1453 — pause between two polls of a derivation running on the server. */
export var DERIVE_POLL_INTERVAL_MS = 2000;
var sleep = function (ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); };
/**
 * Run the derivation now and resolve with its `DeriveReport` once it finished.
 * `dryRun=true` counts what would happen without writing; `dryRun=false` (the
 * default) performs the real run and writes a run audit row. Used for both
 * the first derive and the "Přegenerovat" (re-derive) affordance — there is
 * only one derive action.
 *
 * CZNA-1453 — two requests, because one run can take minutes and Kong ends a
 * request at 60 s (and on the test cluster then repeats the POST, which started
 * the same run four times). `POST .../derive?ruleId=&dryRun=` answers 202 with
 * a job handle; `GET .../derive/{jobId}` answers 202 while the run is going and
 * 200 with the report when it is done. A failed run answers with its own error
 * status, so the caller's `onError` sees the same `HTTPError` the single
 * synchronous call used to throw. The promise stays pending for the whole run,
 * which is what keeps the button disabled exactly as before.
 *
 * @param wait injectable pause, for tests
 */
export var deriveVocabularyDerivationRule = function (ky_1, ruleId_1, dryRun_1) {
    var args_1 = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args_1[_i - 3] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1, ruleId_1, dryRun_1], args_1, true), void 0, function (ky, ruleId, dryRun, wait) {
        var sp, job, jobPath, response, report;
        if (wait === void 0) { wait = sleep; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sp = new URLSearchParams({ ruleId: ruleId, dryRun: String(dryRun) });
                    return [4 /*yield*/, ky.post("".concat(API_PATHS.CZNA_VOCABULARY_DERIVATION_RULES_DERIVE, "?").concat(sp.toString()), {
                            headers: getHeaders(),
                        }).json()];
                case 1:
                    job = _a.sent();
                    jobPath = "".concat(API_PATHS.CZNA_VOCABULARY_DERIVATION_RULES_DERIVE, "/").concat(encodeURIComponent(job.jobId));
                    _a.label = 2;
                case 2: 
                // Sequential by nature: each poll decides whether there is a next one.
                // eslint-disable-next-line no-await-in-loop
                return [4 /*yield*/, wait(DERIVE_POLL_INTERVAL_MS)];
                case 3:
                    // Sequential by nature: each poll decides whether there is a next one.
                    // eslint-disable-next-line no-await-in-loop
                    _a.sent();
                    return [4 /*yield*/, ky.get(jobPath, { headers: getHeaders() })];
                case 4:
                    response = _a.sent();
                    if (!(response.status !== 202)) return [3 /*break*/, 6];
                    return [4 /*yield*/, response.json()];
                case 5:
                    report = _a.sent();
                    return [2 /*return*/, report];
                case 6: return [3 /*break*/, 2];
                case 7: return [2 /*return*/];
            }
        });
    });
};
